<template>
  <div id="printable" class="summary-container">
    <!-- Header -->
    <div class="header">
      <div class="facility-name">
        TUURU COTTOLENGO HEALTH CENTRE - AR2026259
      </div>
      <div class="facility-details">
        <div>Igembe Central</div>
        <div>P.O BOX 77 - Meru | Tel: 254254746758069</div>
        <div>Email: suore.tuuru@cottolengo.org</div>
      </div>
      <div class="register-title">MOH 710 - IMMUNIZATION SUMMARY REPORT</div>
    </div>

    <!-- Month/Year and Generated By Bar -->
    <div class="info-bar">
      <div class="info-left">
        <div class="info-item">
          <span class="info-label">Month:</span>
          <select v-model="selectedMonth" class="month-select">
            <option value="January">January</option>
            <option value="February">February</option>
            <option value="March">March</option>
            <option value="April">April</option>
            <option value="May">May</option>
            <option value="June">June</option>
            <option value="July">July</option>
            <option value="August">August</option>
            <option value="September">September</option>
            <option value="October">October</option>
            <option value="November">November</option>
            <option value="December">December</option>
          </select>
        </div>
        <div class="info-item">
          <span class="info-label">Year:</span>
          <input
            type="number"
            v-model="selectedYear"
            class="year-input"
            min="2020"
            max="2030"
          />
        </div>
        <div class="info-item">
          <span class="info-label">Generated By:</span>
          <span class="info-value">{{ generatedBy }}</span>
        </div>
      </div>
      <button @click="printPage" class="btn-print">Print Summary</button>
    </div>

    <!-- Period Display for Print -->
    <div class="print-period">
      <strong>Reporting Period:</strong> {{ selectedMonth }} {{ selectedYear }}
    </div>

    <!-- Section 1: Target Population -->
    <div class="section">
      <div class="section-title">1. TARGET POPULATION</div>
      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-label">Target Infants (less than 1 year)</div>
          <div class="stat-value">{{ targetPopulation.infants }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">Target Pregnant Women</div>
          <div class="stat-value">{{ targetPopulation.pregnantWomen }}</div>
        </div>
      </div>
    </div>

    <!-- Section 2: BCG Vaccination -->
    <div class="section">
      <div class="section-title">
        2. BCG VACCINATION (At birth or first contact)
      </div>
      <div class="stats-grid-2">
        <div class="stat-card">
          <div class="stat-label">BCG Given</div>
          <div class="stat-value">{{ bcg.given }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">Coverage (%)</div>
          <div class="stat-value">{{ bcg.coverage }}%</div>
        </div>
      </div>
    </div>

    <!-- Section 3: OPV Vaccination -->
    <div class="section">
      <div class="section-title">3. ORAL POLIO VACCINE (OPV)</div>
      <div class="table-wrapper">
        <table class="data-table">
          <thead>
            <tr>
              <th>Vaccine</th>
              <th>Target</th>
              <th>Given</th>
              <th>Coverage (%)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="opv in opvData" :key="opv.name">
              <td>{{ opv.name }}</td>
              <td>{{ opv.target }}</td>
              <td>{{ opv.given }}</td>
              <td>{{ opv.coverage }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Section 4: DPT-HepB-Hib Vaccination -->
    <div class="section">
      <div class="section-title">4. DPT-HepB-Hib VACCINATION (Pentavalent)</div>
      <div class="table-wrapper">
        <table class="data-table">
          <thead>
            <tr>
              <th>Vaccine</th>
              <th>Target</th>
              <th>Given</th>
              <th>Coverage (%)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dpt in dptData" :key="dpt.name">
              <td>{{ dpt.name }}</td>
              <td>{{ dpt.target }}</td>
              <td>{{ dpt.given }}</td>
              <td>{{ dpt.coverage }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Section 5: PCV Vaccination -->
    <div class="section">
      <div class="section-title">5. PNEUMOCOCCAL CONJUGATE VACCINE (PCV)</div>
      <div class="table-wrapper">
        <table class="data-table">
          <thead>
            <tr>
              <th>Vaccine</th>
              <th>Target</th>
              <th>Given</th>
              <th>Coverage (%)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="pcv in pcvData" :key="pcv.name">
              <td>{{ pcv.name }}</td>
              <td>{{ pcv.target }}</td>
              <td>{{ pcv.given }}</td>
              <td>{{ pcv.coverage }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Section 6: Rota Virus Vaccination -->
    <div class="section">
      <div class="section-title">6. ROTA VIRUS VACCINE (RVV)</div>
      <div class="table-wrapper">
        <table class="data-table">
          <thead>
            <tr>
              <th>Vaccine</th>
              <th>Target</th>
              <th>Given</th>
              <th>Coverage (%)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="rvv in rvvData" :key="rvv.name">
              <td>{{ rvv.name }}</td>
              <td>{{ rvv.target }}</td>
              <td>{{ rvv.given }}</td>
              <td>{{ rvv.coverage }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Section 7: Measles/Rubella Vaccination -->
    <div class="section">
      <div class="section-title">7. MEASLES/RUBELLA (MR) VACCINATION</div>
      <div class="table-wrapper">
        <table class="data-table">
          <thead>
            <tr>
              <th>Vaccine</th>
              <th>Target</th>
              <th>Given</th>
              <th>Coverage (%)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="mr in mrData" :key="mr.name">
              <td>{{ mr.name }}</td>
              <td>{{ mr.target }}</td>
              <td>{{ mr.given }}</td>
              <td>{{ mr.coverage }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Section 8: Vitamin A Supplementation -->
    <div class="section">
      <div class="section-title">8. VITAMIN A SUPPLEMENTATION</div>
      <div class="table-wrapper">
        <table class="data-table">
          <thead>
            <tr>
              <th>Dose</th>
              <th>Target</th>
              <th>Given</th>
              <th>Coverage (%)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="vitA in vitaminAData" :key="vitA.dose">
              <td>{{ vitA.dose }}</td>
              <td>{{ vitA.target }}</td>
              <td>{{ vitA.given }}</td>
              <td>{{ vitA.coverage }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Section 9: Tetanus Toxoid for Pregnant Women -->
    <div class="section">
      <div class="section-title">9. TETANUS TOXOID (TT) FOR PREGNANT WOMEN</div>
      <div class="table-wrapper">
        <table class="data-table">
          <thead>
            <tr>
              <th>Dose</th>
              <th>Target</th>
              <th>Given</th>
              <th>Coverage (%)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="tt in ttData" :key="tt.dose">
              <td>{{ tt.dose }}</td>
              <td>{{ tt.target }}</td>
              <td>{{ tt.given }}</td>
              <td>{{ tt.coverage }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Section 10: Dropout Rates -->
    <div class="section">
      <div class="section-title">10. DROPOUT RATES</div>
      <div class="stats-grid">
        <div class="stat-card warning">
          <div class="stat-label">DPT1 to DPT3 Dropout</div>
          <div class="stat-value">{{ dropoutRates.dpt1ToDpt3 }}%</div>
        </div>
        <div class="stat-card warning">
          <div class="stat-label">BCG to MR Dropout</div>
          <div class="stat-value">{{ dropoutRates.bcgToMr }}%</div>
        </div>
        <div class="stat-card warning">
          <div class="stat-label">Penta1 to Penta3 Dropout</div>
          <div class="stat-value">{{ dropoutRates.penta1ToPenta3 }}%</div>
        </div>
      </div>
    </div>

    <!-- Section 11: Defaulters Tracing Summary -->
    <div class="section">
      <div class="section-title">11. DEFAULTERS TRACING SUMMARY</div>
      <div class="stats-grid-2">
        <div class="stat-card">
          <div class="stat-label">Defaulters Identified</div>
          <div class="stat-value">{{ defaulters.identified }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">Successfully Traced</div>
          <div class="stat-value">{{ defaulters.traced }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">Returned for Vaccination</div>
          <div class="stat-value">{{ defaulters.returned }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">Still Defaulting</div>
          <div class="stat-value">{{ defaulters.stillDefaulting }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MOH710Summary",
  data() {
    return {
      selectedMonth: "April",
      selectedYear: 2026,
      generatedBy: "SR. JANE KAREGI MUNYUGI",

      targetPopulation: {
        infants: 245,
        pregnantWomen: 189,
      },

      bcg: {
        given: 238,
        coverage: 97.1,
      },

      opvData: [
        { name: "OPV 0 (At birth)", target: 245, given: 240, coverage: 98.0 },
        { name: "OPV 1 (6 weeks)", target: 240, given: 232, coverage: 96.7 },
        { name: "OPV 2 (10 weeks)", target: 235, given: 225, coverage: 95.7 },
        { name: "OPV 3 (14 weeks)", target: 230, given: 218, coverage: 94.8 },
      ],

      dptData: [
        {
          name: "DPT-HepB-Hib 1 (6 weeks)",
          target: 240,
          given: 235,
          coverage: 97.9,
        },
        {
          name: "DPT-HepB-Hib 2 (10 weeks)",
          target: 235,
          given: 228,
          coverage: 97.0,
        },
        {
          name: "DPT-HepB-Hib 3 (14 weeks)",
          target: 230,
          given: 220,
          coverage: 95.7,
        },
      ],

      pcvData: [
        { name: "PCV 1 (6 weeks)", target: 240, given: 233, coverage: 97.1 },
        { name: "PCV 2 (10 weeks)", target: 235, given: 226, coverage: 96.2 },
        { name: "PCV 3 (14 weeks)", target: 230, given: 215, coverage: 93.5 },
      ],

      rvvData: [
        { name: "RVV 1 (6 weeks)", target: 240, given: 230, coverage: 95.8 },
        { name: "RVV 2 (10 weeks)", target: 235, given: 222, coverage: 94.5 },
      ],

      mrData: [
        { name: "MR 1 (9 months)", target: 220, given: 205, coverage: 93.2 },
        { name: "MR 2 (18 months)", target: 210, given: 190, coverage: 90.5 },
      ],

      vitaminAData: [
        {
          dose: "1st dose (6 months)",
          target: 220,
          given: 208,
          coverage: 94.5,
        },
        {
          dose: "2nd dose (12 months)",
          target: 215,
          given: 198,
          coverage: 92.1,
        },
        {
          dose: "3rd dose (18 months)",
          target: 210,
          given: 185,
          coverage: 88.1,
        },
        {
          dose: "4th dose (24 months)",
          target: 205,
          given: 178,
          coverage: 86.8,
        },
        {
          dose: "5th dose (30 months)",
          target: 200,
          given: 170,
          coverage: 85.0,
        },
        {
          dose: "6th dose (36 months)",
          target: 195,
          given: 162,
          coverage: 83.1,
        },
      ],

      ttData: [
        { dose: "TT 1", target: 189, given: 182, coverage: 96.3 },
        { dose: "TT 2", target: 185, given: 175, coverage: 94.6 },
        { dose: "TT 3", target: 180, given: 168, coverage: 93.3 },
        { dose: "TT 4", target: 175, given: 160, coverage: 91.4 },
        { dose: "TT 5", target: 170, given: 152, coverage: 89.4 },
      ],

      dropoutRates: {
        dpt1ToDpt3: 6.4,
        bcgToMr: 11.6,
        penta1ToPenta3: 6.4,
      },

      defaulters: {
        identified: 45,
        traced: 38,
        returned: 32,
        stillDefaulting: 13,
      },
    };
  },
  methods: {
    printPage() {
      window.print();
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.summary-container {
  background: white;
  min-height: 100vh;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1a56db;
}

.facility-name {
  font-size: 20px;
  font-weight: bold;
  color: #1a56db;
  margin-bottom: 6px;
}

.facility-details {
  font-size: 11px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 10px;
}

.register-title {
  font-size: 14px;
  font-weight: bold;
  background: #f3f4f6;
  display: inline-block;
  padding: 5px 16px;
  border-radius: 20px;
  color: #1f2937;
}

.info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.info-left {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  align-items: center;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.info-value {
  font-size: 12px;
  color: #1f2937;
  font-weight: 500;
}

.month-select {
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
  background: white;
}

.year-input {
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
  width: 70px;
}

.btn-print {
  padding: 8px 20px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
}

.btn-print:hover {
  background: #2563eb;
}

.print-period {
  text-align: center;
  padding: 8px;
  margin-bottom: 20px;
  background: #fef3c7;
  border-left: 4px solid #f59e0b;
  font-size: 12px;
  color: #92400e;
  border-radius: 6px;
}

.section {
  margin-bottom: 28px;
}

.section-title {
  font-size: 14px;
  font-weight: bold;
  color: #1f2937;
  background: #e5e7eb;
  padding: 8px 12px;
  border-radius: 8px;
  margin-bottom: 12px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 10px;
}

.stats-grid-2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  max-width: 600px;
}

.stat-card {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 10px;
  padding: 12px 16px;
  text-align: center;
}

.stat-card.warning {
  background: #fef3c7;
  border-color: #fde68a;
}

.stat-card.warning .stat-value {
  color: #d97706;
}

.stat-label {
  font-size: 11px;
  font-weight: 600;
  color: #166534;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.stat-card.warning .stat-label {
  color: #92400e;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #059669;
}

.table-wrapper {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.data-table th {
  background: #1f2937;
  color: white;
  padding: 8px;
  text-align: center;
  border: 1px solid #374151;
}

.data-table td {
  border: 1px solid #d1d5db;
  padding: 8px;
  text-align: center;
}

.data-table td:first-child {
  text-align: left;
  font-weight: 500;
}

@media print {
  @page {
    size: portrait;
    margin: 0.5cm;
  }

  .btn-print,
  .month-select,
  .year-input {
    display: none;
  }

  .info-bar {
    display: none;
  }

  .print-period {
    background: #fef3c7;
    margin: 10px 0;
    padding: 5px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .summary-container {
    padding: 0.2cm;
  }

  .header {
    margin-bottom: 5px;
  }

  .facility-name {
    font-size: 14px;
  }

  .facility-details {
    font-size: 8px;
  }

  .register-title {
    font-size: 10px;
  }

  .section-title {
    font-size: 11px;
    padding: 4px 8px;
  }

  .stat-value {
    font-size: 18px;
  }

  .stat-label {
    font-size: 9px;
  }

  .data-table {
    font-size: 9px;
  }

  .data-table th,
  .data-table td {
    padding: 4px;
  }

  .stat-card {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>
